import React from "react";
import {SectionHeading} from "peggirkit";
import {useIntl} from "react-intl";
import SynchronizationLogsSectionHeadingActions
    from "@widgets/synchronization/overview/heading/sectionHeading/SynchronizationLogsSectionHeadingActions";
import {SetStateFn} from "@/utils/SetStateUtils";

type Props = {
    setShowDeleteLogsModal: SetStateFn<boolean>,
};

const SynchronizationLogsSectionHeading = ({setShowDeleteLogsModal}: Props) => {
    const intl = useIntl();
    const actions = (
        <SynchronizationLogsSectionHeadingActions
            setShowDeleteLogsModal={setShowDeleteLogsModal}
        />
    );

    return (
        <SectionHeading
            title={intl.formatMessage({id: "logs"})}
            description={intl.formatMessage({id: "syncLogsOverviewDescription"})}
            actions={{
                actionRow: actions,
                horizontal: false,
            }}
            breakpoints={{
                md: {
                    actions: {
                        actionRow: actions,
                        horizontal: true,
                    },
                },
            }}
        />
    );
};

export default SynchronizationLogsSectionHeading;